'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPointerInside;

var _globalOffset = require('global-offset');

var _globalOffset2 = _interopRequireDefault(_globalOffset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPointerInside(el, _ref) {
  var pageX = _ref.pageX,
      pageY = _ref.pageY;

  var _offset = (0, _globalOffset2.default)(el),
      left = _offset.left,
      top = _offset.top;

  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;


  return pageX >= left && pageX <= left + offsetWidth && pageY >= top && pageY <= top + offsetHeight;
}
module.exports = exports['default'];
